import { Component, ElementRef, Injector } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudEditorParentService, CrudEditorSelfService, UserStorage } from '@scisys-uim/uim-common';
import { AssetsUserDetailsService, FirearmAssignmentService, FirearmService, FirearmStorageLocationService, RangerService, RefCodeStorage, TransferAssetService } from 'assets-service';
import { FirearmAssignmentItemComponentBase } from './firearm-assignment-item.component.base';
import { ASSETS_USER_DETAILS_TYPE, FIREARM_TYPE, RANGER_TYPE } from 'assets-model';


@Component({
  selector: 'app-firearm-assignment-item',
  templateUrl: './firearm-assignment-item.component.html',
  styleUrls: ['./firearm-assignment-item.component.scss'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class FirearmAssignmentItemComponent extends FirearmAssignmentItemComponentBase {

  constructor(protected firearmAssignmentService: FirearmAssignmentService,
    protected firearmService: FirearmService,
    protected gunDealerLocationService: FirearmStorageLocationService,
    protected locationService: FirearmStorageLocationService,
    protected rangerService: RangerService,
    protected transferAssetService: TransferAssetService,
    protected userService: AssetsUserDetailsService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(firearmAssignmentService, firearmService, gunDealerLocationService, locationService, rangerService, transferAssetService, userService, refCodeStorage, fb, elementRef, router, route, userStorage, dialog, injector, snackbar);
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
    this.firearmAssignmentTypeLoadSelectionList();
    this.storageTypeLoadSelectionList();
    this.locationLoadSelectionList();
    this.lifecycleStateLoadSelectionList();
    this.nextActionLoadSelectionList();
    this.rangerLoadSelectionList();
  }
      
  itemSet() {
    super.itemSet();
    this.firearmLoadSelectionList();
    this.rangerLoadSelectionList();
    this.userLoadSelectionList();
  }

  setDefaultDisabledFields() {
    if (!this.form) {
      return;
    }

    this.firearmAssignmentId?.disable();
    this.firearm?.disable();
    this.user?.disable();
    this.ranger?.disable();
    this.handoverAcknowledgedBy?.disable();
    this.handoverAcknowledgedDate?.disable();
    this.endDate?.disable();
    this.createdDate?.disable();
    this.createdBy?.disable();
    this.updatedDate?.disable();
    this.updatedBy?.disable();
  }

  
  firearmLoadSelectionList() {
    this.firearmSelectionList = FIREARM_TYPE.entityDecorator.ensureContained(this.item && this.item.firearm, []);
  }
  rangerLoadSelectionList() {
    this.rangerSelectionList = RANGER_TYPE.entityDecorator.ensureContained(this.item && this.item.ranger, []);
  }
  userLoadSelectionList() {
    this.userSelectionList = ASSETS_USER_DETAILS_TYPE.entityDecorator.ensureContained(this.item && this.item.user, []);
  }
}





